/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseCouponUsageParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['successAt', parsers.moment, 'success_at'],
    ['userId', codecNumber, 'user_id'],
]);
export class BaseCouponUsage extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseCouponUsageParser.decode(input).map(res => new BaseCouponUsage(res));
    }
    static unsafeDecode(input) {
        return BaseCouponUsage.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseCouponUsageParser.encode(data);
    }
    static schema() {
        return BaseCouponUsageParser.schema();
    }
}
